import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../shared-zorro.module';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserService } from '../service/user.service';
import { environment } from '../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-ef',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './ef.component.html',
  styleUrl: './ef.component.less',
})
export class EfComponent {
  isMobile: boolean = false;
  id: string = '';
  caseId: string = '';
  showMask: boolean = false;
  linkInfo: any = {};
  verifyCode: string = '';
  caseInfo: any = {};
  safeUrl: any = '';
  type: number = 0;
  constructor(private route: ActivatedRoute, private userService: UserService, private message: NzMessageService, private router: Router, private sanitizer: DomSanitizer) {
    this.route.params.subscribe((params) => {
      this.id = params['id']; // 获取路由参数中的 key
    });
    //获取链接中的code http://localhost:6200/ef/tl8scA9hZ4tF?code=xxxx
    this.route.queryParams.subscribe((params) => {
      this.verifyCode = params['code'];
    });
    //判断是不是移动端
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
  }
  ngOnInit() {
    this.getEFLinkInfo(this.id);
    // 修改标题
    document.title = '云起医澜数字胶片';
  }

  //查询链接信息
  getEFLinkInfo(id: string) {
    this.userService.getEFLinkInfo(id).subscribe((res: any) => {
      if (res.code === 0) {
        this.linkInfo = res.data.linkInfo;
        let query = res.data.linkInfo.query;
        // query: "caseId=10041"
        this.caseId = query.split('=')[1];
        this.checkVerifyCode();
      } else {
        this.message.error('查询失败');
      }
    });
  }

  //校验是否需要验证码
  checkVerifyCode() {
    if (this.linkInfo.verifyCode) {
      this.showMask = true;
    } else {
      this.showMask = false;
      this.getEFDetail();
    }
  }

  //校验验证码
  confirmVerifyCode() {
    if (this.verifyCode === '') {
      this.message.error('请输入验证码');
      return;
    }
    if (this.verifyCode !== this.linkInfo.verifyCode) {
      this.message.error('验证码错误');
      return;
    } else {
      this.showMask = false;
      this.getEFDetail();
    }
  }

  //获取病例详情
  getEFDetail() {
    this.userService.getEFDetail(this.caseId).subscribe((res: any) => {
      if (res.code === 0) {
        this.caseInfo = res.data;
        this.updateViewerURL();
      } else {
        this.message.error('查询失败');
      }
    });
  }

  updateViewerURL() {
    let url = environment.host + '/viewer/' + this.caseInfo.studyInstanceUID;
    console.log('viewerUR=>' + url);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
